export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13194.40dfe8d3.jpg";